// web_components/wcAwards/wcAwards_Renderer.ts

/**
 * Generates the HTML for the wc-awards component.
 * Handles CSS, variables, etc.
 *
 * @param {object} dataAttributes - Data attributes for styling and contextual information.
 * @param {string} instanceId - A unique instance ID for generating unique element IDs.
 * @returns {string} - The HTML string for the content component.
 */
export function renderProductHTML(dataAttributes: any, instanceId: string): string {
	// Initialize styleTag to an empty string
	let styleTag = '';

	// Check if 'css' exists in dataAttributes and is an object
	if (dataAttributes.css && typeof dataAttributes.css === 'object') {
		styleTag = `<style>`;
		for (const [selector, styles] of Object.entries(dataAttributes.css)) {
			styleTag += `${selector} { ${styles} }`;
		}
		styleTag += `</style>`;
	}

	// Access variables and assign to 'variables', defaulting to an empty object if undefined
	const variables = dataAttributes.variables || {};

	return `
        ${styleTag}
        <section id="${instanceId}" class="wc-awards">
        	<div class="wc-awards__container">
				<div class="wc-awards__text-block">
					<h2 class="wc-awards__heading">
						${variables.heading}
					</h2>
					<p>
						${variables.awardsCopy}
					</p>
				</div>
				<div class="wc-awards__image-block">
					<img class="wc-awards__image" src="${variables.image1}" alt="${variables.image1_alt}">
					<img class="wc-awards__image" src="${variables.image2}" alt="${variables.image2_alt}">
					<img class="wc-awards__image" src="${variables.image3}" alt="${variables.image3_alt}">
					<img class="wc-awards__image" src="${variables.image4}" alt="${variables.image4_alt}">

				</div>
			</div>
		</section>
    `;
}
